import React, { useState } from "react";

// Reusable collapsible wrapper used for the "Edit Job" and "Supervisor"
// action containers in the Job Details popup. Hidden by default when the
// popup first opens; the header toggle shows/hides the buttons inside.
const CollapsibleActionSection = ({
  title,
  tone = "default",
  defaultOpen = false,
  children,
  style,
}) => {
  const [open, setOpen] = useState(defaultOpen);

  if (!children) return null;

  return (
    <section
      className={`job-action-section job-action-section--${tone}`}
      style={{ margin: "12px 0", ...style }}
    >
      <div
        role="button"
        tabIndex={0}
        onClick={() => setOpen((prev) => !prev)}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            setOpen((prev) => !prev);
          }
        }}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          cursor: "pointer",
          userSelect: "none",
        }}
      >
        <h3 style={{ margin: 0 }}>{title}</h3>
        <button
          type="button"
          className="smallazul-button"
          onClick={(e) => {
            e.stopPropagation();
            setOpen((prev) => !prev);
          }}
        >
          {open ? "Hide" : "Show"}
        </button>
      </div>

      {open && (
        <div className="job-action-section__buttons" style={{ marginTop: 10 }}>
          {children}
        </div>
      )}
    </section>
  );
};

export default CollapsibleActionSection;
